module.exports = __webpack_public_path__ + "img/chart.356cfdd0.png";